import { useEffect, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { Button } from "@headlessui/react";
import Select from "../../components/input/Select";
import { useAddExistingTeacherMutation, useAvailableTeachersQuery } from "./manageCourseApiSlice";
import { handleEnterKey } from "../../app/keyboardUtils";

interface Props {
	courseId?: number;
	saveButtonText?: string;
	setErrorMessage?: (message: string) => void;
	onClose: () => void;
	onSwitchToNewTab?: () => void;
}

export default function AddExistingTeacherForm(props: Props) {
	const [selectedTeacher, setSelectedTeacher] = useState("");

	const availableTeachersResult = useAvailableTeachersQuery(props.courseId ?? skipToken);
	const availableTeachers = availableTeachersResult.data;

	const [addCoteacher] = useAddExistingTeacherMutation();

	useEffect(() => {
		if (availableTeachers && availableTeachers?.length > 0) {
			setSelectedTeacher(availableTeachers[0].value.toString());
		} else if (availableTeachers && availableTeachers.length === 0 && props.onSwitchToNewTab) {
			props.onSwitchToNewTab();
		}
	}, [availableTeachers, props.onSwitchToNewTab]);

	function handleAddTeacher() {
		if (props.courseId && selectedTeacher) {
			addCoteacher({ courseId: props.courseId, userId: Number(selectedTeacher) })
				.unwrap()
				.then(() => {
					if (props.setErrorMessage) props.setErrorMessage("");
					props.onClose();
				});
		}
	}

	function handleCancel() {
		props.onClose();
	}

	return (
		<section>
			{availableTeachers && availableTeachers.length > 0 ? (
				<Select
					value={selectedTeacher}
					setValue={(v) => setSelectedTeacher(v as string)}
					simpleListBoxId="teacherDropdown"
					options={availableTeachers}
					label="Name:"
					fieldClasses="pt-3"
					simpleListBoxClasses="w-full"
				/>
			) : (
				<div className="mt-4 px-4 py-4 bg-gray-50 border border-gray-200 rounded-lg">
					<p className="text-gray-700 text-center">
						There are no teachers available to add to the course.
					</p>
				</div>
			)}
			<div className="mt-6 grid grid-cols-2 gap-3">
				<Button
					id="cancel-button"
					onClick={handleCancel}
					onKeyDown={(e) => handleEnterKey(e, handleCancel)}
					className="btn btn-neutral">
					Cancel
				</Button>
				<Button
					id="confirm-button"
					disabled={!selectedTeacher}
					onClick={handleAddTeacher}
					onKeyDown={(e) => handleEnterKey(e, handleAddTeacher)}
					className="btn btn-primary">
					{props.saveButtonText ?? "Add Teacher"}
				</Button>
			</div>
		</section>
	);
}
